import { handleCreateForumCategory, handleUpdateForumCategory } from "../../../redux/admin-slices/forums.slice"
import { hideDialog, refresher, toastError } from "../../../redux/guest-slices/other.slice"
import { CREATE_FORUM_CATEGORY } from "../../../utils/keywords"
import SkeletonImage from "../../common/SkeletonImage"
import { useDispatch, useSelector } from "react-redux"
import InputFieldA from "../../ui/InputFieldA"
import Icons from "../../../assets/js/Icons"
import { useState, useRef } from "react"

import {
  Box, Button, CircularProgress, DialogActions, DialogContent,
  DialogTitle, Icon, IconButton, InputLabel, Paper, Stack, Typography
} from "@mui/material"
import { useEffect } from "react"
import { FILE_PATH_URI } from "../../../utils/helper"

function ForumCategory() {
  const files = useRef()
  const dispatch = useDispatch()
  const [image, setImage] = useState(null)
  const { type, data, loadings } = useSelector(state => state.otherSlice)

  // Close dialog
  const handleClose = () => {
    dispatch(hideDialog())
  }

  // Handle image preview
  const handleImagePreview = (e) => {
    if (e.target.files.length) {
      files.current = Array.from(e.target.files)
      const views = files.current?.map(img => URL.createObjectURL(img))
      setImage(views?.[0])
    }
  }

  // Handle create  
  const handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target
    const formData = Object.fromEntries(new FormData(form))
    formData.banner = files?.current || data?.category?.banner || []
    if ([
      formData?.name,
      formData?.banner,
    ]?.some((value) =>
      typeof value === "string" ?
        (value?.trim() === "" || !value) :
        Array.isArray(value) ?
          !Boolean(value?.length) :
          !value
    )
    ) {
      return dispatch(toastError("Category name and image is required!"))
    }

    if (type === CREATE_FORUM_CATEGORY) {
      dispatch(handleCreateForumCategory(formData)
      ).unwrap().then(() => {
        setTimeout(() => {
          handleClose()
          dispatch(refresher())
        }, 500)
      }).catch(() => { })
    } else {
      dispatch(handleUpdateForumCategory({
        formData,
        id: data?.category?._id,
      })
      ).unwrap().then(() => {
        setTimeout(() => {
          handleClose()
          dispatch(refresher())
        }, 500)
      }).catch(() => { })
    }
  }

  useEffect(() => {
    if (data?.category?.banner) {
      setImage(FILE_PATH_URI + data?.category?.banner?.path || "")
    }
    // eslint-disable-next-line
  }, [])

  return (
    <Paper component="form" onSubmit={handleSubmit}>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            m: "0",
            fontSize: "24px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >Create New Category
        </Typography>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "other.color1",
            position: "absolute",
          }}
          size="small"
          onClick={handleClose}
        ><Icons.CancelSolid />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
        }}
      >
        <Stack spacing={1.5}>
          <Box>
            <InputFieldA
              type="text"
              name="name"
              placeholder="Enter Name"
              value={data?.category?.name}
              label={<>
                Name*
                <Typography
                  variant="body2"
                  component="span"
                  color="inherit"
                > (In any language)
                </Typography>
              </>}
            />
          </Box>
          <InputLabel
            sx={{
              mb: 0,
              height: "100%",
              maxHeight: 300,
              borderRadius: "8px",
              border: "1px dashed",
              placeContent: "center",
              borderColor: "primary.main",
              display: image ? "block" : "grid",
            }}
          >
            {image ?
              <SkeletonImage sx={{ objectFit: "contain" }} src={image || null} /> :
              <>
                <Icon sx={{ fontSize: "100px", color: "other.color2", m: "auto", "svg": { display: "block" } }}>
                  <Icons.ImageSolid />
                </Icon>
                <Typography
                  mb={1.5}
                  color="other.color2"
                >Upload banner image
                </Typography>
              </>
            }
            <input style={{ display: "none" }} onChange={handleImagePreview} accept="image/*" type="file" />
            {/*  */}
          </InputLabel>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", px: 3 }}>
        <Button
          type="submit"
          color="success"
          variant="contained"
          sx={{ minWidth: 120 }}
          endIcon={(
            loadings?.create ||
            loadings?.update
          ) &&
            <CircularProgress
              size={20}
              thickness={5}
              sx={{ color: "white" }}
            />
          }
        >
          {type === CREATE_FORUM_CATEGORY ?
            "Create" : "Update"
          }
        </Button>
      </DialogActions>
    </Paper>
  )
}

export default ForumCategory